// extracted by mini-css-extract-plugin
module.exports = {"container":"PageCard_container__3fTVY"};